<template>
    <div class="card">
        <h4>Aggiungi un proprietario</h4>
        <p>Cerca un profilo esistente</p>
        <profile-add role="owner" :school-id="schoolId"
                     v-on:added-profile="addedOwner()"
                     v-on:closed-editor="closeEditor()" />

        <hr>
        <h5>Crea un nuovo profilo</h5>
        <div v-if="!submitted">
            <b-form @submit.stop.prevent="saveOwner">
                <b-form-group id="firstname" label="Nome" label-for="firstname" description="">
                    <b-form-input
                        v-model="owner.firstname"
                        placeholder=""
                        :state="validateState('firstname')"
                        aria-describedby="firstname-live-feedback"></b-form-input>
                    <b-form-invalid-feedback
                        id="firstname-live-feedback"
                    >Questo campo è obbligatorio e deve contenere almeno 3 caratteri.</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="lastname" label="Cognome" label-for="lastname" description="">
                    <b-form-input
                        v-model="owner.lastname"
                        placeholder=""
                        :state="validateState('lastname')"
                        aria-describedby="lastname-live-feedback"></b-form-input>
                    <b-form-invalid-feedback
                        id="lastname-live-feedback"
                    >Questo campo è obbligatorio e deve contenere almeno 3 caratteri.</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="email" label="Email" label-for="email" description="">
                    <b-form-input
                        v-model="owner.email"
                        placeholder=""
                        type="email"
                        :state="validateState('email')"
                        aria-describedby="email-live-feedback"></b-form-input>
                    <b-form-invalid-feedback
                        id="email-live-feedback"
                    >Questo campo è obbligatorio e deve essere un'email valida.</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="password" label="Password" label-for="password" description="">
                    <b-form-input
                        v-model="owner.password"
                        placeholder=""
                        type="text"
                        :state="validateState('password')"
                        aria-describedby="password-live-feedback"></b-form-input>
                    <b-form-invalid-feedback
                        id="password-live-feedback"
                    >Questo campo è obbligatorio.</b-form-invalid-feedback>
                </b-form-group>

                Confermato: <toggle-button v-model="owner.confirmed" :height="25"/>

            </b-form>


            <div class="action-bar row">
                <div class="col-sm-8">
                    <button class="btn btn-success " @click="saveOwner" :disabled="this.$store.state.loading"><b-icon icon="file-earmark-check"/> Salva</button>
                    <b-button variant="link" @click="closeEditor" :disabled="this.$store.state.loading"><b-icon icon="x"/> Chiudi</b-button>
                </div>
                <div class="col-sm-4 text-right">

                </div>
            </div>
            <div>
                <br>
                <b-alert variant="success" :show="message != ''" fade><b-icon icon="hand-thumbs-up"/> {{ message }}</b-alert>
                <b-alert variant="danger" :show="errorMsg != ''">{{ errorMsg }}</b-alert>
            </div>
        </div>

    </div>
</template>

<script>
import OwnerDataService from "./OwnerDataService";
import ProfileAdd from "@/components/profile/ProfileAdd";
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
    name: "owner-create",
    components: {ProfileAdd},
    data() {
        return {
            owner: {
                id: null,
                firstname: "",
                lastname: "",
                email: "",
                password: "",
                active: true,
                confirmed: false
            },
            message: '',
            errorMsg: '',
            submitted: false
        };
    },
    props: ["schoolId"],
    validations: {
        owner: {
            firstname: {
                required,
                minLength: minLength(4)
            },
            lastname: {
                required,
                minLength: minLength(4)
            },
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(4)
            }
        }
    },
    methods: {
        validateState(name) {
            const { $dirty, $error } = this.$v.owner[name];
            return $dirty ? !$error : null;
        },
        saveOwner() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.submitted = false;
            } else {
                this.owner.schoolId = this.schoolId;
                OwnerDataService.create(this.owner)
                    .then(response => {
                        this.owner.id = response.data.id;
                        this.submitted = true;
                        this.$emit('created-owner');
                    })
                    .catch(e => {
                        this.errorMsg = 'Non hai compilato tutti i campi';
                        console.log(e);
                    });
            }
        },
        addedOwner() {
            this.$emit('created-owner');
        },
        closeEditor() {
            this.$emit('closed-editor');
        }
    },
    mounted() {

    }
};
</script>

<style>

</style>
